<template>
  <div>
    <div
      v-if="serviceRatings"
      v-lazy-container="{ selector: 'img' }"
      class="default content"
      v-html="serviceRatings"
    />
    <div class="score-list">
      <header v-if="scoreList.length > 0">
        <p v-show="scores.totalCount">
          根據 <span class="main-color bold-font">{{ scores.totalCount }}則 </span>用戶好評
        </p>
        <p
          v-show="scores.avgScore"
          class="star"
        >
          {{ scores.avgScore }}<i class="icon-star-filled" />
        </p>
        <p>滿分為5顆星</p>
      </header>
      <section
        v-for="(score, index) in scoreList"
        :key="index"
      >
        <header>
          <p class="name">
            {{ score.name }}
          </p>
          <div class="detail">
            <span class="star">
              <i class="icon-star-filled" />{{ score.score }}
            </span>
            <span>
              {{ score.score_time }}
            </span>
            <span>
              {{ score.city }}{{ score.area }}
            </span>
          </div>
        </header>
        <div
          v-if="score.ScorePictureList.length"
          class="photo"
        >
          <div class="img-wrap">
            <div
              v-for="(photo, photoIndex) in score.ScorePictureList"
              :key="photoIndex"
              class="img"
              :style="`background-image:url(${photo.FilePath})`"
              @click="browserImage(score.ScorePictureList, photoIndex)"
            />
          </div>
        </div>
        <div
          v-if="score.ScoreTagList.length"
          class="tag-list"
        >
          <div class="tag-wrap">
            <v-chip
              v-for="(tag, tagIndex) in score.ScoreTagList"
              :key="tagIndex"
              class="tag"
            >
              {{ tag.TagName }}
            </v-chip>
          </div>
        </div>
        <div
          v-if="score.note"
          class="content bold-font"
          v-html="score.note.replace(/\n/g, '<br>')"
        />
        <div
          v-if="score.reply"
          class="replay"
        >
          <header>
            <p class="replay-title">
              <img
                src="@/assets/image/quokka/admin-quokka.png"
                alt="智寶"
              >
              智樂家回應
            </p>
            <p class="replay-date">
              {{ $dayjs(score.reply.reply_time).format('YYYY/MM/DD') }}
            </p>
          </header>
          <p class="replay-content">
            <template v-for="(reply, index) in score.reply.reply_content">
              {{ reply }}
              <br
                v-if="index < score.reply.reply_content.length - 1"
                :key="index"
              >
            </template>
          </p>
        </div>
      </section>
      <v-btn
        v-if="scores.totalCount === 0 && String(service.service_ratings).length === 0"
        class="load-more none"
        text
        readonly
      >
        尚無用戶好評
      </v-btn>
      <v-btn
        v-else-if="scoreList.length < scores.totalCount && scoreList.length > 0"
        class="load-more"
        text
        @click="loadMore"
      >
        查看更多用戶好評
      </v-btn>
      <v-btn
        v-else-if="scoreList.length >= scores.totalCount && scores.totalCount !== null"
        class="load-more all"
        text
        readonly
      >
        已顯示所有用戶好評
      </v-btn>
      <div
        v-show="isLoading"
        v-if="scoreList.length < scores.totalCount"
        class="loading"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serviceMainUrl: {
      type: String
    }
  },
  asyncData ({ params }) {
    return {
      serviceId: params.service
    }
  },
  data () {
    return {
      isLoading: false,
      scores: {
        page: 1,
        preCount: 10,
        avgScore: null,
        totalCount: null
      },
      scoreList: [],
      serviceRatings: null
    }
  },
  head () {
    return {
      link: [
        { hid: 'canonical', rel: 'canonical', href: this.serviceMainUrl }
      ]
    }
  },
  computed: {
    service () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    }
  },
  async mounted () {
    this.replaceImageSrc()
    if (this.service?.ServiceScores?.scores && this.service?.ServiceScores?.scores.length) {
      this.renderScoreList(this.service.ServiceScores.scores)
    } else {
      await this.getScoreList()
    }
    this.scores.avgScore = this.service.ServiceScores.avgScore
    this.scores.totalCount = this.service.ServiceScores.totalCount
  },
  methods: {
    replaceImageSrc () {
      this.serviceRatings = this.service.service_ratings.replace(/<img([^>]*)src=["']([^"']*)["']([^>]*)>/gi, (match, p1, p2, p3) =>
        `<img${p1}data-src="${p2}"${p3}>`
      )
    },
    async getScoreList () {
      this.isLoading = true
      const scoresList = await this.$store.dispatch('service/getServiceScores', {
        id: this.serviceId,
        page: this.scores.page,
        preCount: this.scores.preCount
      })
      this.renderScoreList(scoresList)
      this.isLoading = false
    },
    renderScoreList (scoresList = []) {
      const renderScoresList = _.cloneDeep(scoresList).map(score => {
        const nameArray = Array.from(score.name)
        let name = ''
        for (let i = 0; i < nameArray.length; i++) {
          name += i % 2 === 0 ? nameArray[i] : '＊'
        }
        score.name = name
        score.score_time = score.score_time ? this.$dayjs(score.score_time).format('YYYY/MM/DD') : ''
        if (score.reply_detail && score.reply_detail.length > 0) {
          score.reply = {
            ...score.reply_detail[0],
            reply_content: score.reply_detail[0].reply_content.split('\n')
          }
        }
        if (score.ScorePictureList && score.ScorePictureList.length) {
          score.ScorePictureList = score.ScorePictureList.sort((a, b) => a.IsAfter - b.IsAfter)
          score.ScorePictureList = score.ScorePictureList.map(img => {
            return {
              ...img,
              imageUrl: img.FilePath
            }
          })
        }
        return score
      })
      this.scoreList.push(...renderScoresList)
    },
    loadMore () {
      this.scores.page = this.scores.page + 1
      this.getScoreList()
    },
    browserImage (imageList, index) {
      this.$store.dispatch('imageBrowser', {
        isOpen: true,
        imageList,
        activeIndex: index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-color {
  color: $mainColor;
}
.bold-font {
  font-weight: bold;
}
.score-list {
  text-align: center;
  > header {
    position: relative;
    padding-bottom: 20px;
    margin-bottom: 25px;
    border-bottom: 5px solid $grayColor;
    .star {
      margin-bottom: 10px;
      font-size: pxTorem(28px);
      line-height: pxTorem(28px);
      font-weight: bold;
      i {
        margin-left: 10px;
        color: $yellowColor;
      }
    }
    p {
      color: #999999;
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
    }
  }
  section {
    $marginWidth: 12px;
    width: calc(100% - #{$marginWidth} * 2);
    margin-left: auto;
    margin-right: auto;
    padding: 15px;
    text-align: left;
    border-bottom: 2px solid $grayColor;
    & + section {
      margin-top: 20px;
    }
    > header {
      margin-bottom: 10px;
      p.name {
        font-size: pxTorem(16px);
        line-height: pxTorem(20px);
        font-weight: bold;
        margin-bottom: 5px;
      }
      .detail {
        display: flex;
        align-items: center;
        span {
          padding: 0 10px;
          font-size: pxTorem(16px);
          line-height: pxTorem(20px);
          color: #999999;
          border-right: 1px solid #707070;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            border-right: none;
          }
        }
        .star {
          font-size: pxTorem(18px);
          line-height: pxTorem(25px);
          font-weight: 600;
          color: $fontColor;
          vertical-align: middle;
          i {
            display: inline-block;
            font-size: pxTorem(16px);
            line-height: pxTorem(16px);
            padding: 0 5px;
            color: $yellowColor;
            font-size: 20px;
          }
        }
      }
    }
    > .content {
      font-size: pxTorem(16px);
      line-height: pxTorem(20px);
      word-break: break-word;
    }
    .replay {
      position: relative;
      margin-top: 12px;
      padding: 8px 12px;
      background-color: #F2F2F2;
      border-radius: 2px;
      &:after {
        content: '';
        bottom: 100%;
        left: 28px;
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 8px 8px 8px;
        border-color: transparent transparent #f2f2f2 transparent;
      }
      img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
      }
      p {
        margin-bottom: 0;
      }
      header {
        display: flex;
        margin-bottom: 8px;
        justify-content: space-between;
        font-size: pxTorem(13px);
        line-height: pxTorem(18px);
        p.replay-title {
          display: flex;
          align-items: center;
          font-weight: 600;
        }
        p.replay-date {
          font-weight: 400;
          color: #999999;
        }
      }
      .replay-content {
        margin-left: 34px;
        font-weight: 400;
        font-size: pxTorem(15px);
        line-height: pxTorem(21px);
        word-break: break-word;
      }
    }
  }
  .load-more {
    margin-top: 30px;
    color: $mainColor;
    font-size: pxTorem(16px);
    line-height: pxTorem(20px);
    text-decoration: underline;
    text-align: center;
    &.all, &.none {
      text-decoration: none;
    }
  }
  .loading {
    text-align: center;
    padding: 10px 0;
  }
}
.img-wrap {
  .img {
    width: 100px;
    height: 100px;
    display: inline-block;
    margin-right: 8px;
    border-radius: 4px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: $lightGrayColor;
    &:hover {
      cursor: pointer;
    }
  }
}
.tag-wrap {
  margin: 12px 0;
  .tag {
    margin-right: 8px;
    margin-bottom: 8px;
    background-color: $lightGrayColor;
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .score-list {
    > header {
      margin-bottom: 18px;
      .star {
        margin-bottom: 5px;
        font-size: pxTorem(24px);
        line-height: pxTorem(24px);
      }
      p {
        font-size: pxTorem(14px);
        line-height: pxTorem(21px);
      }
      span {
        right: 0;
        font-size: pxTorem(13px);
        line-height: pxTorem(18px);
      }
    }
    section {
      padding: 12px 0 12px 20px;
      width: 100%;
      & + section {
        margin-top: 15px;
      }
      header {
        .detail {
          span {
            font-size: pxTorem(15px);
            line-height: pxTorem(20px);
          }
          .star {
            i {
              padding: 0;
              margin-right: 5px;
            }
          }
        }
      }
      .content {
        font-size: pxTorem(15px);
      }
      .img-wrap {
        white-space: nowrap;
        overflow-y: auto;
        .img {
          width: 72px;
          height: 72px;
        }
      }
    }
    .load-more {
      margin-top: 20px;
    }
  }
}
</style>
